import { useCallback, useState } from 'react';

export function useTouchedFields<K extends string>() {
    const [touched, setTouched] = useState<Partial<Record<K, true>>>({});

    const touch = useCallback((field: K) => {
        setTouched((prev) => (prev[field] ? prev : { ...prev, [field]: true }));
    }, []);

    const touchAll = useCallback((fields: readonly K[]) => {
        setTouched((prev) => {
            const next = { ...prev };
            for (const field of fields) {
                next[field] = true;
            }
            return next;
        });
    }, []);

    const resetTouched = useCallback(() => {
        setTouched({});
    }, []);

    const fieldError = useCallback(
        (field: K, message: string | undefined): string | undefined =>
            touched[field] && message ? message : undefined,
        [touched],
    );

    return { touch, touchAll, resetTouched, fieldError };
}
